export default __webpack_public_path__ + "static/olympicPark6-874a1b43c14fe1ea910b7e7276f6d1b4.jpeg";